import Median from 'median-js-bridge';
import { useCallback, useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const TABS = {
  '/': 0,
  '/user/favorite-events': 1,
  '/user/orders': 3,
  '/user/orders/[orderId]': 3,
  '/user/profile': 4,
};

// tabs config median settings
const BASE_TABS = [
  {
    icon: 'custom icon-frame-10',
    label: 'Home',
    url: 'https://jlive.app/',
  },
  {
    icon: 'custom icon-frame-9',
    label: 'Favorites',
    url: 'https://jlive.app/user/favorite-events',
  },
  {
    label: 'Search',
    icon: 'custom icon-frame-8',
    // eslint-disable-next-line no-script-url
    url: 'javascript:window.onSearchEventsClick();',
  },
  {
    icon: 'far fa-ticket-simple',
    label: 'My Tickets',
    url: 'https://jlive.app/user/orders',
  },
  {
    label: 'Profile',
    icon: 'custom icon-frame-6',
    url: 'https://jlive.app/user/profile',
  },
];

const HIDE_SEARCH_PATHS = [
  '/events/[eventId]/tickets',
  '/events/[eventId]/registration',
  '/events/[eventId]/order/summary',
  '/events/[eventId]/order/payment-method',
  '/events/[eventId]/order/send-to',
];

const useMedian = () => {
  const [isMedian, setIsMedian] = useState(false);
  const router = useRouter();

  useEffect(() => {
    setIsMedian(navigator.userAgent.includes('median'));
    Median.onReady(() => setIsMedian(Median.isNativeApp()));
  }, []);

  const selectSearchTab = () => Median.tabNavigation.selectTab(2);

  const detectTab = useCallback(() => {
    Median.tabNavigation.deselect();
    const tabIndex = TABS[router.pathname as keyof typeof TABS];
    if (tabIndex !== undefined) {
      Median.tabNavigation.selectTab(tabIndex);
    }
  }, [router.pathname]);

  const updateTabs = useCallback(() => {
    const shouldHide = HIDE_SEARCH_PATHS.some((path) => {
      const regex = new RegExp(path.replace('[eventId]', '[^/]+').replace(/\//g, '\\/'));
      return regex.test(router.pathname);
    });

    const updatedTabs = shouldHide ? BASE_TABS.filter((tab) => tab.label !== 'Search') : BASE_TABS;

    Median.tabNavigation.setTabs({
      enabled: true,
      items: updatedTabs,
    });
  }, [router.pathname]);

  useEffect(() => {
    if (isMedian) {
      detectTab();
      updateTabs();
    }
  }, [isMedian, detectTab, updateTabs]);

  return {
    isMedian,
    detectTab,
    selectSearchTab,
  };
};

export default useMedian;
